export enum ETheme {
  DARK = 'DARK',
  LIGHT = 'LIGHT',
}
